import React, {FC, ReactElement} from "react";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {ListItemIcon, ListItemText, MenuItem} from "@mui/material";
import {routes} from "./Routes";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import {observer} from "mobx-react";


export const SubscriptionMenuItem: FC = observer((): ReactElement => {
    const {t} = useTranslation();

    return <MenuItem component={Link} to={routes.billing}>
        <ListItemIcon>
            <SubscriptionsIcon/>
        </ListItemIcon>
        <ListItemText primary={t("user_menu.Subscription", "Subscription")}/>
    </MenuItem>
})